import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const notificationFilter = async (recordId, moduleName) => {
  const data = {
    ModuleName: moduleName,
    RecordId: recordId,
  };
  return await axios
    .post(`${api_base_url}/NotificationFilter/SearchName`, data)
    .then((res) => res.data);
};

export const notificationFilterById = async (
  recordId,
  moduleName,
  subModuleName,
  action
) => {
  const data = {
    ModuleName: moduleName,
    RecordId: recordId,
    SubModuleName: subModuleName,
    Action: action,
  };
  return await axios
    .post(`${api_base_url}/NotificationFilter/FilterById`, data)
    .then((res) => {
      if (res && res.data) {
        return res.data;
      } else {
        return res;
      }
    });
};

// export const notificationFilter = async (moduleName,recordId) => {
//   const { data } = await axios.get(`${api_base_url}/NotificationFilter/SearchName`);
//   const data1 = {
//     ModuleName: moduleName,
//     RecordId: recordId
//   };
//   //const { data } = await axios.get("https://localhost:44399/api/TargetSyStem");
//   return data;
// };
